// Define enums for roles
export const SafeguardRoles = {
  SAFEGUARD_ADMIN_WRITE: 'safeguard_admin_write',
  SAFEGUARD_ADMIN_READ: 'safeguard_admin_read',
  SAFEGUARD_DEV: 'safeguard_dev',
  SAFEGUARD_MANUFACTURING: 'safeguard_manufacturing',
};
